import { ExternalLinkCreationPanelAction, ExternalLinkCreationPanelActionKeys } from './actions';

type Fields = {
	name: string;
	url: string;
};

interface ExternalLinkCreationPanelState {
	isOpen: boolean;
	fields: Fields;
	errors: { [k: string]: string | null };
}

const initialState: ExternalLinkCreationPanelState = {
	isOpen: false,
	fields: {
		name: '',
		url: '',
	},
	errors: {},
};

function externalLinkCreationPanel(state: ExternalLinkCreationPanelState = initialState, action: ExternalLinkCreationPanelAction): ExternalLinkCreationPanelState {
	switch (action.type) {
		case ExternalLinkCreationPanelActionKeys.OPEN_PANEL:
			return {
				...state,
				isOpen: true,
			};
		case ExternalLinkCreationPanelActionKeys.CLOSE_PANEL:
			return initialState;
		case ExternalLinkCreationPanelActionKeys.SET_VALUE:
			return {
				...state,
				fields: {
					...state.fields,
					[action.name]: action.value,
				},
				errors: {
					...state.errors,
					[action.name]: action.error,
				},
			};
		default:
			return state;
	}
}

export {
	ExternalLinkCreationPanelState,
	externalLinkCreationPanel,
	Fields,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ExternalLinkCreationPanel/reducer.ts